import React, { useState } from 'react';

import { Drawer, CuiOptionType, Radio } from '@crehana/ui';
import Sort from '@crehana/icons/dist/outline/Sort';
import { primaryMain } from '@crehana/ui/dist/styles/colors';
import { getSourceEventParams, useAmplitude } from '@crehana/analytics';

import { useTranslation } from '@crehana/i18n';

import { useAppContext } from 'Jsx/Catalog/context/AppContext';

import DrawerMobileContent from '../DrawerMobileContent';

const OrderByMobile = () => {
  const { t } = useTranslation();
  const { logEvent } = useAmplitude();
  const [isVisible, setIsVisible] = useState(false);

  const toggleDrawer = () => {
    setIsVisible(prev => !prev);
  };

  const {
    orderBy: { items, itemSelected },
    orderByActions,
  } = useAppContext();

  const onChange = (item: CuiOptionType<string>) => {
    // @ts-ignore Popper uses CuiOptionType but actully resunts OrderByOption here
    orderByActions.selectOrderBy(item);
    setIsVisible(false);

    logEvent({
      event: 'Catalog Sort',
      data: {
        'Sort Type': item.label,
        ...getSourceEventParams(),
      },
    });
  };

  return (
    <div className="w-1/2">
      <button
        type="button"
        className="flex items-center justify-center w-full text-primary-main"
        onClick={toggleDrawer}
      >
        <Sort size={24} color={primaryMain} className="min-w-24 mr-8" />
        <span className="font-subtitle4 flex-shrink-0">
          {/* {itemSelected.label} */}
          {t('SORT_BY')}
        </span>
      </button>

      <Drawer
        open={isVisible}
        position="right"
        onDismiss={toggleDrawer}
        onEscape={toggleDrawer}
        unmountChildrenOnClose
      >
        <DrawerMobileContent
          title={t('CATALOG_ORDER_BY')}
          closeDialog={toggleDrawer}
        >
          <ul className="px-16">
            {items.map(item => (
              <li key={item.value} className="mb-12">
                <Radio
                  label={item.label}
                  checked={itemSelected?.name === item?.name}
                  onChange={() => onChange(item)}
                />
              </li>
            ))}
          </ul>
        </DrawerMobileContent>
      </Drawer>
    </div>
  );
};

export default OrderByMobile;
